const callAPI = async (
  url: string,
  body?: Record<string, unknown>,
  method?: string
): Promise<unknown> => {
  try {
    const response = await fetch(url, {
      method: method || 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      ...(body && { body: JSON.stringify(body) })
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data?.message || data.error || 'Something went wrong, please try again');
    }
    return data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export default callAPI;

export const callPaginatedAPI = async (url: string, body?: any, method?: string) => {
  try {
    const response = await fetch(url, {
      method: method || 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      ...(body && { body: JSON.stringify(body) })
    });
    const data = {
      data: await response.json(),
      totalItems: Number(response.headers.get('X-Total-Count')),
      totalPages: Number(response.headers.get('X-Total-Pages'))
    };
    if (!response.ok) {
      throw new Error(data?.message || data.error || 'Something went wrong, please try again');
    }
    return data;
  } catch (error) {
    console.log(error);
  }
};
